import { render, staticRenderFns } from "./AnswerImage.vue?vue&type=template&id=47eecb2a&scoped=true&lang=pug&"
import script from "./AnswerImage.vue?vue&type=script&lang=ts&"
export * from "./AnswerImage.vue?vue&type=script&lang=ts&"
import style0 from "./AnswerImage.vue?vue&type=style&index=0&id=47eecb2a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eecb2a",
  null
  
)

component.options.__file = "AnswerImage.vue"
export default component.exports